module.exports = __webpack_public_path__ + "494cd07c/img/arrow-export-icon.a3345173.svg";